import React from 'react';
import { Grid, TextField } from '@material-ui/core';
import TeamFilterHierarchyOutlined from '../../../components/TeamFilterHierarchyOutlined';

const RepInfoSection = ({
  repInfo,
  team,
  handleTeamChange,
  hireDate,
  setHireDate,
  teamHierarchy,
}) => {
  if (!repInfo) return null;
  
  // Convert ISO date string to YYYY-MM-DD format for the input field
  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    // If it's already in YYYY-MM-DD format, return as is
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) return dateString;
    // If it's an ISO string, extract the date part
    return dateString.split('T')[0];
  };

  // Handle date change and convert to ISO format for storage
  const handleDateChange = (e) => {
    const dateValue = e.target.value; // This will be in YYYY-MM-DD format
    if (dateValue) {
      // Convert to ISO format with time set to midnight UTC
      const isoDate = new Date(dateValue + 'T00:00:00.000Z').toISOString();
      setHireDate(isoDate);
    } else {
      setHireDate('');
    }
  };

  console.log('HireDate_Debug', hireDate);
  
  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <TextField
          fullWidth
          label="First Name"
          variant="outlined"
          value={repInfo.First_Name || ''}
          disabled
          InputProps={{
            readOnly: true,
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          label="Last Name"
          variant="outlined"
          value={repInfo.Last_Name || ''}
          disabled
          InputProps={{
            readOnly: true,
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <TeamFilterHierarchyOutlined
          label="Team:"
          value={team}
          onTeamChange={val => {
            handleTeamChange(val);
          }}
          name="team"
          data={teamHierarchy?.parentChildrenTeamFilter?.filters[0]?.teams}
          labelColorCondition={false}
          renderValue={selected => selected === "" ? "Please Select a Team" : selected}
          getOptionLabel={option => option.label}
          getOptionValue={option => option.parentValue + option.label}
          style={{ width: '100%', background: '#fafafd', borderRadius: 2, }}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          label="Hire Date"
          variant="outlined"
          type="date"
          value={formatDateForInput(hireDate)}
          onChange={handleDateChange}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default RepInfoSection;